import React from 'react'
import { fetchRecalculateAttendance } from '../../utils/commonFunction';

const RecalculateAttendanceButton = ({ launchDetail }) => {
    return (
        launchDetail.big_blue_button_id?.length > 0 && (
            <button
                className="btn btn-primary btn-sidebar mr-2 mt-2"
                title="Recalculate Attendance"
                onClick={async () => {
                    await fetchRecalculateAttendance(launchDetail.big_blue_button_id);
                }}
            >
                <i className="fa fa-refresh"></i> Recalculate Attendance
            </button>
        )
    )
}

export default RecalculateAttendanceButton